import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { UiService } from '@core/services/ui.service';

@Component({
  selector: 'gt-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage {
  public isForgotSubmitted = false;
  public forgotForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private authService: AuthService,
    private uiService: UiService,
    public location: Location,
  ) {}

  resetPassword() {
    this.isForgotSubmitted = true;
    const emailControl = this.forgotForm.controls.email;
    emailControl.setValue(emailControl.value?.trim() ?? '');
    if (this.forgotForm.valid && this.forgotForm.value.email) {
      this.uiService.showLoading();
      this.authService
        .resetPassword(this.forgotForm.value.email)
        .then(() => {
          this.uiService.showToast('ONBOARDING.FORGOT_PASSWORD.OK');
          this.location.back();
          this.uiService.hideLoading();
        })
        .catch((error) => {
          console.error('Error resetting password:', error);
          this.uiService.showToast('ONBOARDING.FORGOT_PASSWORD.ERROR_EMAIL', 'danger');
          this.uiService.hideLoading();
        });
    }
  }
}
